import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { MatLabel } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select'; 
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatModule } from '../appModules/mat.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ExportService } from '../shared/services/exportservice';

@Component({
  selector: 'app-student-list',
  imports: [
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    CommonModule,
    MatLabel,
    MatSelectModule,
    FormsModule,
    MatPaginatorModule,
    MatModule,
    ReactiveFormsModule
  ],
  templateUrl: './student-list.component.html',
  styleUrl: './student-list.component.scss'
})
export class StudentListComponent {
  students:any;
  courseList:any;
  semesterList:any;
  selectedSemesterId: string = '';
  selectedCourseId: string = '';
  courseId:any;
  semisterId:any;
  searchText: string = '';
  student_list_visible: boolean = true;
  edit_form: boolean = false
  formGroup:FormGroup;
  selectedRegisterNo:any;
  role: any

  pagination = {
    length: 0,
    page: 1,
    limit: 10,
  };
  currentPage=0;
  displayedColumns: string[] = [
    'actions','sno','course-name','student_id', 'name', 'father_name', 'mother_name',
    'register_no', 'scheme_type', 'section', 'email',
    'phone', 'gender', 'dob'
  ];


  constructor(private http: HttpClient, private api: ApiService, private common: CommonService, private fb: FormBuilder, private exportService: ExportService) {
    this.formGroup = this.fb.group({
      name:[''],
      father_name:[''],
      mother_name:[''],
      register_no:[''],
      scheme_type:[''],
      section:[''],
      email:[''],
      phone:[''],
      gender:[''],
      dob:[''],
      course_id:['']
    })
   }

  ngOnInit() {
    this.get_all_students();
    this.getSemesterList();
    this.fetch_courses();
  }

  onEdit(student: any) {
    this.edit_form = true;
    this.student_list_visible = false;
    this.selectedRegisterNo = student.register_no;
  
    this.formGroup.patchValue({
      name: student.name,
      father_name: student.father_name,
      mother_name: student.mother_name,
      register_no: student.register_no,
      scheme_type: student.scheme_type, 
      section: student.section,
      email: student.email,
      phone: student.phone,
      gender: student.gender,
      dob: student.dob,
      course_id: student.course_id
    });
  }

  onDelete(student: any) {
    this.delete_single_student(student.id)
  }
  
  // download() {
  //   const req = {
  //     ...this.displayedColumns,
  //     ...{ data: this.students },
  //     ...{ filename: 'students List' },
  //     ...{ dateField: ['createdAt'] },
  //   };
  //   this.exportService.exportExcel(req);
  // }

  get_all_students_download(courseId?: string, semesterId?: string) {
    const userData = localStorage.getItem('user');

    if (!userData) {
      console.error('No user data found in localStorage');
      return;
    }
  
    const user = JSON.parse(userData);
    interface StudentFilterPayload {
      user_id: string;
      course_id?: string;
      semester_id?: string;
    }
    
    const payload: StudentFilterPayload = {
      user_id: user.userId
    };
    
    if (courseId) {
      payload.course_id = courseId
    }
    if (semesterId) {
      payload.semester_id = semesterId;
    }
  
    this.api.post(`students/list_all_students`, payload, true).subscribe({
      next: (resp: any) => {
        if (resp.status) {
          console.log('students/Students fetched successfully:', resp.data);
          this.students= resp.data;
          this.pagination.length = resp?.totalCount || 0;
          const req = {
            displayedColumns: this.displayedColumns,
            data: this.students,
            filename: 'students_list',
            dateField: ['dob'] // or any date fields if needed
          };
          
          this.exportService.exportExcel(req);
        } else {
          console.error('Failed to fetch students:', resp.message);
        }
      },
      error: (error) => {
        console.error('API error:', error);
      }
    });
  }

  get_all_students(courseId?: string, semester_number?: string, search?: string) {
    const userData = localStorage.getItem('user');

    const queryParam: any = [];
   queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);
  
    if (!userData) {
      console.error('No user data found in localStorage');
      return;
    }
  
    const user = JSON.parse(userData);
    this.role = user.role
    interface StudentFilterPayload {
      user_id: string;
      course_id?: string;
      semester_No?: string;
      search?: String;
    }
    
    const payload: StudentFilterPayload = {
      user_id: user.userId
    };
    
    if (courseId) {
      payload.course_id = courseId
    }
    if (semester_number) {
      payload.semester_No = semester_number;
    }
    if (search){
      payload.search = search
    }
  
    this.api.post(`students/list_all_students?${queryParam.join('&')}`, payload, true).subscribe({
      next: (resp: any) => {
        if (resp.status) {
          console.log('students/Students fetched successfully:', resp.data);
          // You can bind resp.data to a variable for displaying in a table
          this.students= resp.data;
          this.pagination.length = resp?.totalCount || 0;
          resp.data = this.students
        } else {
          console.error('Failed to fetch students:', resp.message);
        }
      },
      error: (error) => {
        console.error('API error:', error);
      }
    });
  }

  // getCourseList() {
  //   this.api.get(`courses/list`).subscribe(resp => {
  //     if (resp && resp.success) {
  //       this.courseList = resp.data;
  //       this.courseId = resp.data.id
  //     } else {
  //       console.error('Failed to load courses:', resp);
  //       this.courseList = [];
  //     }
  //   });
  // }

  fetch_courses(){
    this.api.get('courses/list').subscribe( resp => {
      if(resp.success){
        this.courseList = resp.data;
        this.courseId = resp.data.id
      }
    })
  }

  getSemesterList() {
    this.api.get(`semesters/list`).subscribe(resp => {
      if (resp && resp.success) {
        this.semesterList = resp.data;
        this.semisterId = resp.data.id
      } else {
        console.error('Failed to load semesters:', resp);
        this.semesterList = [];
      }
    });
  }

  delete_student_based_on_filters(courseId: any, semesterId: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        const payload: any = {};
        if (courseId) payload.course_id = courseId;
        if (semesterId) payload.semester_id = semesterId;
  
        this.api.post('students/filter_based_students_delete', payload, true).subscribe(resp => {
          if (resp.status) {
            this.get_all_students();
            Swal.fire('Deleted!', 'The students have been deleted.', 'success');
          } else {
            Swal.fire('Error', resp.message, 'error');
          }
        });
      } else {
        Swal.fire('Cancelled', 'Your delete action was cancelled.', 'error');
      }
    });
  }
  

  delete_single_student(userId:any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          user_id: userId,
        };
        this.api.post('students/filter_based_students_delete', payload, true).subscribe(resp => {
          if (resp.status) {
            this.get_all_students();
            Swal.fire('Deleted!', 'The students have been deleted.', 'success');
          }
        });
      } else {
        Swal.fire('Cancelled', 'Your delete action was cancelled.', 'error');
      }
    });
  }
  

  onFiltersChange() {
    if (this.selectedCourseId, this.selectedSemesterId) {
      this.get_all_students(this.selectedCourseId, this.selectedSemesterId);
    }
  }

  pageEvent(e: any) {
    this.pagination.page = e.pageIndex + 1;
    this.pagination.limit = e.pageSize;
    this.currentPage = e.pageIndex * e.pageSize;
    this.get_all_students(this.selectedCourseId, this.selectedSemesterId);
  }

  isDeleteDisabled(): boolean {
    const userData = localStorage.getItem('user')
    const user = JSON.parse(userData)
    const role = user.role;
    if ( role === 'staff') {
      return !(this.selectedCourseId && this.selectedSemesterId);
    } else {
      return false;
    }
  }
  applyFilter() {
    this.pagination.page = 1;
    this.get_all_students(this.selectedCourseId, this.selectedSemesterId, this.searchText);
  }

  edit_student() {
    const payload = {
      name: this.formGroup.get('name')?.value,
      father_name: this.formGroup.get('father_name')?.value || '',
      mother_name: this.formGroup.get('mother_name')?.value || '',
      register_no: this.selectedRegisterNo,
      new_register_number:this.formGroup.get('register_no')?.value || '',
      scheme_type: this.formGroup.get('scheme_type')?.value,
      section: this.formGroup.get('section')?.value,
      email: this.formGroup.get('email')?.value,
      phone: this.formGroup.get('phone')?.value,
      gender: this.formGroup.get('gender')?.value,
      dob: this.formGroup.get('dob')?.value,
      course_id: this.formGroup.get('course_id')?.value
    };
  
    this.api.post('students/student_edit', { data: payload }, true).subscribe(resp => {
      if (resp.status) {
        Swal.fire({
          icon: 'success',
          title: 'Student Updated',
          text: 'The student information was updated successfully.',
          timer: 2000,
          showConfirmButton: false
        });
        this.edit_form = false;
        this.student_list_visible = true;
  
        // Refresh the list (optional, but useful)
        this.get_all_students();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Update Failed',
          text: resp.message || 'Something went wrong while updating.',
        });
      }
    }, error => {
      Swal.fire({
        icon: 'error',
        title: 'Server Error',
        text: 'Unable to update student due to a server error.',
      });
    });
  }
  

  resetForm(): void {
    this.student_list_visible=true;
    this.formGroup.reset();
   
  }

  back(){
    this.edit_form =false;
    this.student_list_visible=true;  
    this.resetForm();
    this.get_all_students();
   }
}
